import { useCallback } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  const handleNavClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
      if (isHome && href.startsWith("/#")) {
        e.preventDefault();
        const id = href.replace("/#", "");
        const el = document.getElementById(id);
        if (el) {
          const navbarHeight = 80;
          const y = el.getBoundingClientRect().top + window.scrollY - navbarHeight;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }
    },
    [isHome]
  );

  return (
    <footer id="contato" className="bg-foreground-900 text-white rounded-t-3xl mt-0">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div className="space-y-6">
            <img
              src="https://static.readdy.ai/image/73ede18350b422ec86ddf80dcbefc049/3054bd6a58b9c46e1353d0ddcd278821.png"
              alt="RCRED Negócios Financeiros"
              className="h-10 w-auto object-contain rounded-lg"
            />
            <p className="text-foreground-400 text-sm leading-relaxed max-w-xs">
              Soluções em crédito para realizar o sonho da casa própria e alavancar seus investimentos com as melhores taxas do mercado.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.instagram.com/rcred.negocios/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-600 transition-colors"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100084138971032"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-600 transition-colors"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://wa.me/5511985860949"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-600 transition-colors"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-foreground-300 mb-5">
              Navegação
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-foreground-400 hover:text-white text-sm transition-colors underline underline-offset-2">
                  Início
                </a>
              </li>
              <li>
                <a
                  href="/#servicos"
                  onClick={(e) => handleNavClick(e, "/#servicos")}
                  className="text-foreground-400 hover:text-white text-sm transition-colors underline underline-offset-2"
                >
                  Serviços
                </a>
              </li>
              <li>
                <a
                  href="/#sobre"
                  onClick={(e) => handleNavClick(e, "/#sobre")}
                  className="text-foreground-400 hover:text-white text-sm transition-colors underline underline-offset-2"
                >
                  Sobre Nós
                </a>
              </li>
              <li>
                <a
                  href="/#depoimentos"
                  onClick={(e) => handleNavClick(e, "/#depoimentos")}
                  className="text-foreground-400 hover:text-white text-sm transition-colors underline underline-offset-2"
                >
                  Depoimentos
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-foreground-300 mb-5">
              Contato
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 shrink-0">
                  <i className="ri-phone-line text-sm text-primary-400"></i>
                </div>
                <div>
                  <p className="text-sm text-foreground-400">Telefone / WhatsApp</p>
                  <a href="tel:+5511985860949" className="text-white hover:text-primary-400 text-sm transition-colors">
                    (11) 9.8586-0949
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 shrink-0">
                  <i className="ri-mail-line text-sm text-primary-400"></i>
                </div>
                <div>
                  <p className="text-sm text-foreground-400">E-mail</p>
                  <a href="mailto:contato@rcrednegocios.com.br" className="text-white hover:text-primary-400 text-sm transition-colors">
                    contato@rcrednegocios.com.br
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 shrink-0">
                  <i className="ri-map-pin-line text-sm text-primary-400"></i>
                </div>
                <div>
                  <p className="text-sm text-foreground-400">Atendimento</p>
                  <p className="text-white text-sm">Brasil - BR</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs text-center sm:text-left">
              &copy; 2026 RCRED Negócios Financeiros. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-4 text-xs">
              <Link to="/privacidade" className="text-foreground-500 hover:text-foreground-300 transition-colors underline underline-offset-2">
                Política de Privacidade
              </Link>
              <Link to="/termos-de-uso" className="text-foreground-500 hover:text-foreground-300 transition-colors underline underline-offset-2">
                Termos de Uso
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}